import { TextField, Card, Box, Typography, Button } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

const RegisterCard = ({ onRegister, onGoogleSignIn }) => {
  const handleGoogleSignIn = () => onGoogleSignIn();
  const { register, handleSubmit } = useForm();

  return (
    <Card>
      <Card
        raised
        sx={{ display: "flex", flexDirection: "column", p: 2, gap: 1 }}
      >
        <form onSubmit={handleSubmit(onRegister)}>
          <Box display="flex" flexDirection="column" gap={1}>
            <TextField
              label="Username"
              variant="filled"
              size="small"
              {...register("username")}
            />
            <TextField
              label="Email Address"
              variant="filled"
              size="small"
              {...register("email")}
            />
            <TextField
              label="Password"
              variant="filled"
              size="small"
              type="password"
              {...register("password")}
            />
            <Button variant="contained" type="submit">
              Login
            </Button>
          </Box>
        </form>

        <Button
          variant="outlined"
          startIcon={<GoogleIcon />}
          onClick={handleGoogleSignIn}
        >
          Login with Google
        </Button>
        <Typography variant="caption">
          <Link to="/reset">Forgot Password</Link>
        </Typography>
      </Card>
    </Card>
  );
};

RegisterCard.propTypes = {
  onRegister: PropTypes.func,
  onGoogleSignIn: PropTypes.func
};

export default RegisterCard;
